export default __webpack_public_path__ + "fc9bfc9fd1bf01d111bd7679accc4c43.svg";